import DecedentDependants from '@/common/containers/Forms/DecedentDependants/DecedentDependants';

export default DecedentDependants;
